//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventItem from '../event/_item'
import SubscribeTip from './_subscribe_tip'
import PublishMixins from '../event/_publish_mixins'

export default {
    mixins: [
        PublishMixins
    ],
    methods: {
        goMore () {
            this.$emit('goMore')
        }
    },
    components: {
        EventItem,
        SubscribeTip
    },
    props: {
        loading: {
            type: Boolean
        },
        items: {
            type: Array
        },
        total_count: {
            type: Number
        },
        customer_service_info: {
            type: Object
        },
        is_consultant: {
            type: Boolean
        },
        building_event_author: {
            type: Boolean
        },
        photos_url: String,
        house: Object,
    }
}
